import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Column, Headings, Padding } from '../../../..'

const TimesWrapper = styled.div`
    color: grey;
    position: absolute;
    right: 25px;
    top: 50%;
    transform: translateY(-50%);
`
function MessageOption({ message, selected, title }) {
    return (
        <Column left width="300px">
            <Padding left right size="md">
                <Padding top bottom size="xs" hideOverflow title={message}>
                    <Padding size="xs" bottom>
                        <Headings.H5 bold>{title}</Headings.H5>
                    </Padding>
                    {message}
                </Padding>
            </Padding>
            {selected && false && (
                <TimesWrapper>
                    <FontAwesomeIcon icon="times" />
                </TimesWrapper>
            )}
        </Column>
    )
}

MessageOption.propTypes = {
    message: PropTypes.string,
    selected: PropTypes.bool,
    title: PropTypes.string,
}

MessageOption.defaultProps = {
    message: '',
    selected: false,
    title: '',
}

export default MessageOption
